module.exports = __webpack_public_path__ + "img/australia-cervical-cancer-female.e23627b6.png";